export default "__VITE_ASSET__DWwyI3KK__"